// extracted by mini-css-extract-plugin
export default {"container":"Crm_container__rkJcT"};